import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Message from './Message';
import { acknowledgeCaseNote } from '../../reducers/caseNotes';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    height: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper
  }
}));

const Messages = ({
  messages,
  currentUserId,
  isManagement,
  acknowledgeCaseNote: onAcknowledge
}) => {
  const classes = useStyles();

  const ref = useRef();

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    ref.current.scrollTop = ref.current.scrollHeight;
  }, [messages]);

  return (
    <Box className={classes.container} ref={ref}>
      {messages.map((message, index) => (
        <Message
          key={`case-note-${message.id}`}
          id={message.id}
          authorType={message.author_type}
          authorName={message.author_name}
          sentAt={message.created_at}
          currentUserIsTheAuthor={currentUserId === message.author_id}
          message={message.message}
          isMostRecentMessage={isManagement && messages.length - 1 === index}
          acknowledged={message.acknowledged}
          onAcknowledge={onAcknowledge}
        />
      ))}
    </Box>
  );
};

Messages.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  messages: PropTypes.array.isRequired,
  isManagement: PropTypes.bool.isRequired,
  acknowledgeCaseNote: PropTypes.func.isRequired
};

export default connect(
  state => {
    return {
      currentUserId: state.auth.user.id,
      isManagement: state.auth.isManagement
    };
  },
  { acknowledgeCaseNote }
)(Messages);
